/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OrderContentType } from './orderContentType';
import { AssessmentTypeEnum } from './assessmentTypeEnum';


export interface DraftOrderApiModelNew { 
    id: number;
    number: string;
    type: AssessmentTypeEnum;
    employeeId: number;
    employeeTitleBeforeName: string;
    employeeName: string;
    employeeSurname: string;
    employeeTitleAfterName: string;
    employeePersonalNumber: string;
    providerId: number;
    providerName: string;
    createDate: string;
    orderContentType: OrderContentType;
}
export namespace DraftOrderApiModelNew {
}


